import React, { useState, useEffect, useRef } from 'react'
import { useIntl } from 'react-intl'
import { useLocation, useHistory, Link } from 'react-router-dom'
import qs from 'qs'
import pick from 'lodash/pick'

import Api from '@vacationtracker/shared/services/api'
import { useAppDispatch, useAppSelector } from '../../store/hooks'
import { selectAuthUserSlice, setAuthUser } from '../../store/auth-user-slice'
import { FrontendUrls } from '../../types/urls'
import CircularProgress from '../../components/circular-progress'
import * as logger from '../../services/logger'
import { track } from '../../services/analytics/analytics'

const BirthdayConfirmationPage = (): React.ReactElement => {
  const { formatMessage } = useIntl()
  const location = useLocation()
  const history = useHistory()
  const { authUser } = useAppSelector(selectAuthUserSlice)
  const processedRef = useRef(false)
  const [loading, setLoading] = useState(true)
  const dispatch = useAppDispatch()

  const queryParams = qs.parse(location.search, { ignoreQueryPrefix: true })
  const update = queryParams.update as string | undefined

  const announcementMyBirthday = update === 'announcementMyBirthday' ? true : update === 'dontAnnouncementMyBirthday' ? false : undefined

  useEffect(() => {
    if (typeof authUser.announcementMyBirthday === 'boolean') {
      const dashboardUrl = authUser.role === 'User' ? FrontendUrls.userDashboard : FrontendUrls.dashboard
      history.replace(dashboardUrl)
      return
    }

    if (processedRef.current || announcementMyBirthday === undefined || !authUser.id) return
    processedRef.current = true

    const isAdmin = authUser.role === 'Admin'
    Api.post('/core/event', {
      eventType: 'USER_UPDATED',
      eventGroup: 'USER',
      ...pick(authUser, 'name', 'locale', 'hourFormat'),
      userId: authUser.id,
      announcementMyBirthday,
      ...(isAdmin && {
        isNameLocked: authUser.isNameLocked || false,
        email: authUser.email,
        startDate: authUser.startDate,
        isAdmin,
      }),
      imageUrl: authUser.imageUrl || undefined,
    })
      .then(() => {
        if (announcementMyBirthday) {
          import('canvas-confetti').then(({ default: confetti }) => {
            const count = 300
            const originX = window.innerWidth > 991 ? 0.5 + 280 / window.innerWidth / 2 : 0.5
            const defaults = { origin: { x: originX, y: 0.7 } }
            const fire = (particleRatio: number, opts: object) => {
              confetti({ ...defaults, ...opts, particleCount: Math.floor(count * particleRatio) })
            }
            fire(0.25, { spread: 26, startVelocity: 55 })
            fire(0.2, { spread: 60 })
            fire(0.35, { spread: 100, decay: 0.91, scalar: 0.8 })
            fire(0.1, { spread: 120, startVelocity: 25, decay: 0.92, scalar: 1.2 })
            fire(0.1, { spread: 120, startVelocity: 45 })
          })
        }
        dispatch(setAuthUser({ ...authUser, announcementMyBirthday }))
        track('NOTIFICATION_ANNOUNCE_MY_BIRTHDAY', {
          newStatus: announcementMyBirthday,
          source: 'mail',
        })
      })
      .catch((err) => logger.error('BIRTHDAY_ANNOUNCEMENT_UPDATE_FAILED', err))
      .finally(() => {
        setLoading(false)
      })
  }, [authUser.id])

  return (
    <div className="main-content">
      <div className="main-content-body">
        {loading ? (
          <CircularProgress />
        ) : (
          <div className="birthday-confirmation">
            <span>🎂</span>
            <p>
              {formatMessage(
                { id: announcementMyBirthday ? 'accountSettings.birthdayAnnouncement.optedIn' : 'accountSettings.birthdayAnnouncement.optedOut' },
                {
                  link: (chunks: React.ReactNode) => <Link to={FrontendUrls.accountSettings}>{chunks}</Link>,
                }
              )}
            </p>
          </div>
        )}
      </div>
    </div>
  )
}

export default BirthdayConfirmationPage
